import Home from './components/Home.vue'
import Login from './components/Login.vue'
import StoreProducts from './components/StoreProducts.vue'
import OrderConfirm from './components/OrderConfirm.vue'
import OrderHistories from './components/OrderHistories.vue'
import OrderInfo from './components/OrderInfo.vue'
import RangePage from './components/RangePage.vue'
import WarehouseOrders from './components/WarehouseOrders.vue'
import WarehouseOrderInfo from './components/WarehouseOrderInfo.vue'
import ProductsIndex from './components/Products/Index.vue'
import ProductsShow from './components/Products/Show.vue'

export default [
  {
    path: '/',
    component: Home,
  },
  {
    path: '/login/',
    component: Login,
  },

  // Store
  {
    path: '/store/products/',
    component: StoreProducts,
  },
  {
    path: '/store/order/confirm/',
    component: OrderConfirm,
  },
  {
    path: '/store/order/histories/',
    component: OrderHistories,
  },
  {
    path: '/store/order/:orderId/',
    component: OrderInfo,
  },

  // Warehouse
  {
    path: '/warehouse/orders/',
    component: WarehouseOrders,
  },
  {
    path: '/warehouse/products/',
    component: ProductsIndex,
  },
  {
    path: '/warehouse/products/:productId',
    component: ProductsShow,
  },
  {
    path: '/warehouse/order/:orderId/',
    component: WarehouseOrderInfo,
  },
  {
    path: '/warehouse/order/range-page/',
    component: RangePage,
  }
]
